const dutchMobilePhoneRegex = new RegExp("^\\+31(6|970)[0-9]{8}$");
const e164PhoneNumberRegex = new RegExp("^\\+[1-9]\\d{1,14}$");

export const isPartialDutchMobilePhoneNumber = (input: string) => {
    if (!input || input.length === 0) {
        return true; // Allow empty string during editing.
    }

    const dutchMobilePhoneNumber = "+31600000000";
    const testMobilePhoneNumber  = "+3197000000000";

    return isPartialMobileNumberMatch(input, dutchMobilePhoneNumber) || 
            isPartialMobileNumberMatch(input, testMobilePhoneNumber);
}

export const isDutchMobilePhoneNumber = (input: string) : boolean => {
    return dutchMobilePhoneRegex.test(input);
}

const isPartialMobileNumberMatch = (input: string, validPhoneNumber: string) => {
    if (input.length > validPhoneNumber.length) {
        return false; // Check if the input is longer than a valid phone number.
    }

    const tempNumber = input + validPhoneNumber.substring(input.length);

    return dutchMobilePhoneRegex.test(tempNumber);
}

export const isE164PhoneNumber = (input: string) : boolean => {
    return e164PhoneNumberRegex.test(input);
}

export const isPartialE164PhoneNumber = (input: string) : boolean => {
    if (!input || input.length === 0) {
        return true; // Allow empty string during editing.
    }

    if (input.length > 16) {
        return false; // E.164 numbers should not exceed 16 characters.
    }

    const tempNumber = input + "123456789012345".substring(input.length);

    return e164PhoneNumberRegex.test(tempNumber);
}